<app-loader *ngIf="loaderIcon | async"></app-loader>
<div class="modal-header">
  <h5 class="modal-title">UNIT RELINK</h5>
  <button type="button" class="close text-white" (click)="cancel()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="row align-items-end g-3">
    <div class="col-md-3 d-flex align-items-center">
      <label class="field-label me-2 mb-0 text-nowrap">
        Facility
      </label>
      <select class="form-select" [(ngModel)]="selectedFacilityId"
              (ngModelChange)="searchModel.facilityId = $event" name="facilityId">
        <option [ngValue]="null" disabled>
          Select Facility
        </option>
        <option *ngFor="let store of allStores" [ngValue]="store.Id">
          {{ store.Name }}
        </option>
      </select>
    </div>
    <!-- Confirmation Number -->
    <div class="col-md-2 d-flex align-items-center">
      <label class="field-label me-2 mb-0 text-nowrap">
        Confirmation #
      </label>
      <input type="text" class="form-control" [(ngModel)]="searchModel.confirmationNumber"
             name="confirmationNumber">
    </div>
    <!-- Unit Number -->
    <div class="col-md-2 d-flex align-items-center">
      <label class="field-label me-2 mb-0 text-nowrap">
        Unit #
      </label>
      <input type="text" class="form-control" [(ngModel)]="searchModel.unitNumber" name="unitNumber">
    </div>
    <!-- Tenant Name -->
    <div class="col-md-2 d-flex align-items-center">
      <label class="field-label me-2 mb-0  text-nowrap">
        Tenant Name
      </label>
      <input type="text" class="form-control" [(ngModel)]="searchModel.tenantName" name="tenantName">
    </div>
    <!-- Email -->
    <div class="col-md-2 d-flex align-items-center">
      <label class="field-label me-2 mb-0 text-nowrap">
        Email
      </label>
      <input type="text" class="form-control" [(ngModel)]="searchModel.email" name="email">
    </div>
    <!-- Search Button -->
    <div class="col search-btn-container">
      <button class="btn btn-primary" (click)="searchTenantRecords()" [disabled]="!canSearch()">
        SEARCH
      </button>
    </div>
  </div>
</div>
<!-- Result Grid Header -->
<div class="row mx-0 mt-3">
  <div class="scroll_outer">
    <div class="large_scroll_inner">
      <ejs-grid #grid class="table-striped table-ipad" height="300" [dataSource]='resultList' [gridLines]='lines'
                [allowFiltering]="true" [allowSorting]="true" [filterSettings]="filterSettings">
        <e-columns>
          <e-column field="select" headerText="SELECT" width="50" [allowFiltering]="false"
                    [allowSorting]="false" textAlign="Center">
            <ng-template #template let-data>
              <div class="d-flex justify-content-center">
                <input type="radio" name="selectedRecord" (change)="onSelectRecord(data)">
              </div>
            </ng-template>
          </e-column>
          <e-column field="type" headerText="TYPE" textAlign='Center' width="120" [allowSorting]="false"></e-column>
          <e-column field="confirmationNumber" headerText="CONFIRMATION #" textAlign='Center' width="170" [allowSorting]="false"></e-column>
          <e-column field="unitNumber" headerText="UNIT #" textAlign='Center' width="100"></e-column>
          <e-column field="tenantName" headerText="TENANT NAME" textAlign='Center' width="200" [allowSorting]="false"></e-column>
          <e-column field="email" headerText="EMAIL" textAlign='Center' width="250" [allowSorting]="false"></e-column>
          <e-column field="status" headerText="STATUS" textAlign='Center' width="140" [allowSorting]="false"></e-column>
        </e-columns>
      </ejs-grid>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-primary me-3" (click)="cancel()">
    CANCEL
  </button>
  <button type="button" class="btn btn-primary" [disabled]="!selectedRecord || loading" (click)="openRelinkConfirmation(relinkConfirmTemplate)">
    RELINK
  </button>
</div>
<!-- Relink Confirmation -->
<ng-template #relinkConfirmTemplate>

  <div class="modal-header">
    <h5 class="modal-title">Confirm</h5>
    <button type="button" class="close" (click)="modalRef.hide()"> &times;</button>
  </div>

  <div class="modal-body ptb24">
    <p class="mb-0"> Are you sure to relink the record?</p>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary me-3" (click)="modalRef.hide()">
      No
    </button>

    <button type="button" class="btn btn-primary" (click)="proceedRelink()">
      Yes
    </button>
  </div>
</ng-template>

<!-- Remove Link Confirmation -->
<ng-template #removeLinkConfirmTemplate>

  <div class="modal-header">
    <h5 class="modal-title">Remove Link</h5>
    <button type="button" class="close" (click)="modalRef.hide()"> &times;</button>
  </div>

  <div class="modal-body ptb24">
    <p class="mb-0">Remove the link between this email and its associated tenant/lease record?</p>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary me-3" (click)="modalRef.hide()">
      No
    </button>

    <button type="button" class="btn btn-danger" (click)="proceedRemoveLink()">
      Yes, Remove
    </button>
  </div>
</ng-template>
